import { getMinutesAndSecondsStringFromSeconds } from '../../DateTime';
import { isValidObject, isValidString } from '../../Validity';
import { getInitials } from '../../Website';

export const tryDescription = (rugbyTry: any) => {
    if (isValidObject(rugbyTry)) {
        let desc = '';
        if (isValidString(rugbyTry.playerName)) {
            if (isValidString(desc)) {
                desc += ` - ${getInitials(rugbyTry.playerName)}(S)`;
            } else {
                desc += `${getInitials(rugbyTry.playerName)}(S)`;
            }
        }
        if (isValidString(rugbyTry.assistName)) {
            if (isValidString(desc)) {
                desc += ` - ${getInitials(rugbyTry.assistName)}(A)`;
            } else {
                desc += `${getInitials(rugbyTry.assistName)}(A)`;
            }
        }
        if (rugbyTry.timeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(rugbyTry.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(rugbyTry.timeInSeconds);
            }
        }
        if (isValidString(desc)) {
            desc += ' - Try';
        }
        return desc;
    }
    return '';
};

export const conversionDescription = (conversion: any) => {
    if (isValidObject(conversion)) {
        let desc = '';
        if (isValidString(conversion.playerName)) {
            if (isValidString(desc)) {
                desc += ` - ${getInitials(conversion.playerName)}`;
            } else {
                desc += `${getInitials(conversion.playerName)}`;
            }
        }
        if (conversion.timeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(conversion.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(conversion.timeInSeconds);
            }
        }
        if (isValidString(desc)) {
            desc += ' - Conversion';
        }
        return desc;
    }
    return '';
};

export const penaltyKickDescription = (penaltyKick: any) => {
    if (isValidObject(penaltyKick)) {
        let desc = '';
        if (isValidString(penaltyKick.playerName)) {
            if (isValidString(desc)) {
                desc += ` - ${getInitials(penaltyKick.playerName)}`;
            } else {
                desc += `${getInitials(penaltyKick.playerName)}`;
            }
        }
        if (penaltyKick.timeInSeconds !== 0 && penaltyKick.convertedToGoal) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(penaltyKick.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(penaltyKick.timeInSeconds);
            }
        }
        if (isValidString(desc)) {
            if (penaltyKick.convertedToGoal) {
                desc += ' - Penalty Goal';
            } else {
                desc += ' - Penalty Kick';
            }
        }
        return desc;
    }
    return '';
};

export const dropGoalDescription = (dropGoal: any) => {
    if (isValidObject(dropGoal)) {
        let desc = '';
        if (isValidString(dropGoal.playerName)) {
            if (isValidString(desc)) {
                desc += ` - ${getInitials(dropGoal.playerName)}`;
            } else {
                desc += `${getInitials(dropGoal.playerName)}`;
            }
        }
        if (dropGoal.timeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(dropGoal.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(dropGoal.timeInSeconds);
            }
        }
        if (isValidString(desc)) {
            desc += ' - Drop Goal';
        }
        return desc;
    }
    return '';
};

export const foulDescription = (foul: any) => {
    if (isValidObject(foul)) {
        let desc = '';
        if (foul.timeInSeconds !== 0) {
            if (isValidString(desc)) {
                desc += ` - ${getMinutesAndSecondsStringFromSeconds(foul.timeInSeconds)}`;
            } else {
                desc += getMinutesAndSecondsStringFromSeconds(foul.timeInSeconds);
            }
        }
        if (isValidString(desc)) {
            desc += ' - Foul';
            if (foul.yellowCard) {
                desc += ' - Yellow Card';
            }
            if (foul.redCard) {
                desc += ' - Red Card';
            }
        }
        return desc;
    }
    return '';
};
